import type { MouseEvent } from 'react';

import { SaveAlt } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

const ExportButton = ({
  title,
  disabled,
  handleClick
}: {
  title: string;
  disabled: boolean;
  handleClick: (event: MouseEvent<HTMLElement>) => void;
}) => {
  return (
    <Tooltip
      slotProps={{
        popper: {
          sx: { zIndex: 9999 }
        }
      }}
      title={title}
    >
      <IconButton
        disabled={disabled}
        sx={{
          width: 30,
          height: 48,
          p: 0,
          minWidth: 30,
          borderRadius: 0,
          backgroundColor: 'secondary.main'
        }}
        onClick={handleClick}
      >
        <SaveAlt sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  );
};

export default ExportButton;
